import { GetterTree } from 'vuex'
import { CarSpecificationState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<CarSpecificationState, RootState> = {
}
